module.exports = __webpack_public_path__ + "static/media/project-hero.641d72a3.jpg";